// api/groceriesApi.js - ACTUALIZADO CON ENDPOINT DE CATEGORÍAS
import { AUTH_TOKEN_KEY, getAuthHeaders } from './authApi';
import { API_BASE_URL } from '../config/apiConfig';

const parseResponse = async (response) => {
  const data = await response.json();

  if (response.status === 401) {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    window.dispatchEvent(new Event('auth:unauthorized'));
  }

  if (!response.ok || data.success === false) {
    throw new Error(data.message || `HTTP Error: ${response.status}`);
  }

  return data;
};

const groceriesApi = {
  fetchList: async () => {
    const response = await fetch(`${API_BASE_URL}groceries-list.php`, {
      headers: getAuthHeaders(),
    });
    return parseResponse(response);
  },

  fetchCategories: async () => {
    const response = await fetch(`${API_BASE_URL}groceries-categories.php`, {
      headers: getAuthHeaders(),
    });
    return parseResponse(response);
  },

  insertItem: async (itemData) => {
    const response = await fetch(`${API_BASE_URL}groceries-insert.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify(itemData)
    });
    return parseResponse(response);
  },

  editItem: async (itemData) => {
    const response = await fetch(`${API_BASE_URL}groceries-edit.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify(itemData)
    });
    return parseResponse(response);
  },

  deleteItem: async (id) => {
    const response = await fetch(`${API_BASE_URL}groceries-delete.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify({ id: id.toString() })
    });
    return parseResponse(response);
  }
};

export { groceriesApi };